export default __webpack_public_path__ + "static/media/SPONSOR-Soroptimist.bdda9f33.svg";